import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {DateRange} from "@angular/material/datepicker";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {
  CustomDateRangeChangeEventModel
} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range-change-event.model";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {UtilsService} from "@shared-services/utils.service";
import {PaymentBatch, RetailerBatchSummary} from "../../../../transactions/transactions.model";
import {TransactionsService} from "../../../../transactions/transactions.service";
import {BatchType} from "../../../model/run-payouts.model";

@Component({
  selector: 'app-payment-batch-dialog',
  templateUrl: './payment-batch-transactions.component.html',
  styleUrls: ['./payment-batch-transactions.component.scss']
})
export class PaymentBatchTransactionsComponent implements OnInit, AfterViewInit, OnChanges{
  @ViewChild("batchTable") batchTable?: MatTable<any>;
  @Input() batch!: PaymentBatch | null;
  @Output() toggleDrawer = new EventEmitter<boolean>();

  dataSource = new MatTableDataSource<RetailerBatchSummary>();
  displayedColumns = ['retailerCompanyName', 'saleAmountInclTotal', 'rollupNetBalancePayableRounded'];

  filterForm: FormGroup;
  dateRange: DateRange<Date | null> = new DateRange<Date | null>(null, null);

  constructor(public utils: UtilsService,
              public dateUtils: DateUtilsService,
              private transactionsService: TransactionsService) {
    this.filterForm = new FormGroup({
      batchId: new FormControl(null)
    })
  }

  ngOnInit() {
    this.dataSource.data = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["batch"].currentValue) {
      this.batch = {...changes["batch"].currentValue};
      this.loadBatchItems();
    } else {
      this.dataSource.data = [];
    }
  }

  ngAfterViewInit() {
    this.filterForm.valueChanges.subscribe(() => this.loadBatchItems());
  }

  loadBatchItems() {
    let filters = [
      {name: 'paymentBatchUuid', val: this.filterForm.get('batchId')?.value},
      {name: 'fromDate', val: this.dateUtils.displayShortDate(this.dateRange.start)},
      {name: 'toDate', val: this.dateRange.end ? this.dateUtils.displayShortDate(this.dateRange.end) : null}
    ].filter((filter: { name: string, val: any }) => {
      return (!(filter.val === null || filter.val === undefined))
    });
    const page = {size: '1000', page: '0', sort: 'processedDate,desc'};
    const urlItem = this.batch!.payoutType == BatchType.DISTRICT_PAYOUT ? 'client' : 'tenant'

    this.transactionsService.getPayoutHistoryForBatchDateRange(`/run-${urlItem}-payouts/payment-batches/${this.batch!.uuid}/rollup`,  filters)
      .subscribe({
        next: result => {
          this.dataSource.data = result;
        }, error: error => {
          console.log(error);
        }
      })
  }

  getDateRange(event: CustomDateRangeChangeEventModel) {
    if (event.dateRange.start && event.dateRange.end) {
      this.dateRange = event.dateRange;
      this.loadBatchItems()
    }
  }

  close() {
    this.toggleDrawer.emit(false);
  }

  isClient() {
    return this.batch!.payoutType == BatchType.DISTRICT_PAYOUT;
  }
}
